import { OktaAuth } from "@okta/okta-auth-js";
import { RouteConstants } from "./constants/RouteConstants";

export const OKTA_CALLBACK_PATH = RouteConstants.LOGIN_CALLBACK;

export const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}${OKTA_CALLBACK_PATH}`,
  pkce: false,
  responseType: ["token", "id_token"],
  scopes: ["openid", "profile", "email"],
});
